var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-list"},[_c('thead',[_c('tr',_vm._l((_vm.Thead),function(thead){return _c('th',[_vm._v(_vm._s(thead))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.Table),function(index,tbody){return _c('tr',_vm._l((tbody),function(td){return _c('td',[_vm._v(_vm._s(td))])}),0)}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d8faf13","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pack/Table.vue
// module id = 1162
// module chunks = 0